import { gql } from '@apollo/client'

const ALL_PROGRAM_FILTER_CATEGORY_MAPS = gql`
  query ProgramFilterCategoryMapsQuery {
    programFilterCategoriesMaps_LA {
      _id
      data {
        id
        filterCategoryId
        programId
      }
    }
  }
`

export { ALL_PROGRAM_FILTER_CATEGORY_MAPS }
